import React, { Component } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import { LoadIndicator } from 'devextreme-react/load-indicator';

import AntConfirmOTPBox from './AntConfirmOTPBox';
import AntLocalization from '../utils/AntLocalization';

export default class AntConfirmOTPPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let width = this.props.width ? this.props.width : '100%';

        let actionWidth = this.props.actionWidth ? this.props.actionWidth : 100;
        return (
            <React.Fragment>
                <div className="ant-action-pannel" width={width} style={{ backgroundColor: this.props.backgroundColor || '#ffffff' }}>
                    <Box direction="row" height="100%" width={width}>
                        <BoxItem ratio={1}>
                            {this.props.content && (
                                <span className="ant-action-text" style={{ color: this.props.textColor }}>
                                    {AntLocalization.translateText(this.props.content)}
                                </span>
                            )}
                            {this.props.subContent && (
                                <span className="ant-action-sub-text" style={{ color: this.props.textColor }}>
                                    {AntLocalization.translateText(this.props.subContent)}
                                </span>
                            )}
                            {this.props.subContent2 && (
                                <span className="ant-action-sub-text2" style={{ color: this.props.textColor }}>
                                    {AntLocalization.translateText(this.props.subContent2)}
                                </span>
                            )}
                            {this.props.subContent3 && (
                                <span className="ant-action-sub-text3" style={{ color: this.props.textColor }}>
                                    {AntLocalization.translateText(this.props.subContent3)}
                                </span>
                            )}
                        </BoxItem>
                        {this.props.actionText && (
                            <BoxItem baseSize={actionWidth + 10}>
                                <Button
                                    className="ant-action-btn"
                                    type="default"
                                    text={AntLocalization.translateText(this.props.actionText)}
                                    width={actionWidth}
                                    stylingMode="contained"
                                    onClick={() => {
                                        if (this.msgBox)
                                            this.msgBox.show(
                                                {
                                                    title: AntLocalization.translateText(this.props.title),
                                                    content: AntLocalization.translateText(this.props.content)
                                                },
                                                this.props.onClose
                                            );
                                    }}
                                >
                                    <span className="dx-button-text">{AntLocalization.translateText(this.props.actionText)}</span>
                                </Button>
                            </BoxItem>
                        )}
                    </Box>

                    <AntConfirmOTPBox
                        session={this.props.session}
                        actionName={this.props.actionName}
                        onSucceed={this.props.onSucceed}
                        formData={this.props.formData}
                        params={this.props.params}
                        ref={(ref) => {
                            this.msgBox = ref;
                        }}
                    />
                </div>
            </React.Fragment>
        );
    }
}
